import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import nisanFlower from '../assets/nisanarkaplan (1).png';



const Engagement = () => {
    const navigate = useNavigate();

    // Nişan tarihi - 1 Temmuz 2028 Cumartesi
    const [engagementDate] = useState(new Date('2028-07-01T18:00:00'));

    // Geri sayım için state
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    // Sayfa yüklendiğinde en üste scroll et
    useEffect(() => {
        window.scrollTo(0, 0);

        // Fontları yükle
        const link = document.createElement('link');
        link.href = 'https://fonts.googleapis.com/css2?family=Cormorant+SC:wght@300;400;500;600;700&family=Montserrat:wght@300;400;500;600;700&family=Playfair+Display:wght@400;500;600;700&display=swap';
        link.rel = 'stylesheet';
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, []);

    // Geri sayım timer'ı
    useEffect(() => {
        const timer = setInterval(() => {
            const now = new Date().getTime();
            const distance = engagementDate.getTime() - now;

            if (distance > 0) {
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                setTimeLeft({ days, hours, minutes, seconds });
            } else {
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [engagementDate]);

    // Detaylara scroll
    const scrollToDetails = () => {
        const infoSection = document.getElementById('engagement-info');
        if (infoSection) {
            infoSection.scrollIntoView({ behavior: 'smooth' });
        } else {
            window.scrollTo({
                top: window.innerHeight,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div className="min-h-screen flex flex-col">

            {/* Hero Section - Görseldeki gibi düzenlenmiş */}
            <section
                className="relative h-screen w-full bg-gradient-to-br from-gray-50 to-white"
                style={{
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    height: '100vh',
                    width: '100%'
                }}
            >
                {/* İçerik konteynerı - Sol tarafa konumlandırılmış */}
                <div className="absolute inset-0 flex items-center justify-start pt-0 md:pt-0 lg:pt-0">
                    <div className="w-full md:w-1/2 md:ml-40 lg:ml-80 xl:ml-96 pl-6 md:pl-0 lg:w-2/5 mt-[-120px] md:mt-[-150px] lg:mt-[-180px]">
                        {/* Nişan Töreni Başlığı */}
                        <div className="mb-6 md:mb-8">
                            <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-medium text-[#556B2F] font-['Cormorant_SC']">
                                Nişan Töreni
                            </h1>
                        </div>

                        {/* Tarih Bilgisi */}
                        <div className="flex items-center space-x-2 md:space-x-4 mb-4 md:mb-6">
                            <span className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-medium text-[#556B2F] font-['Cormorant_SC']">01</span>
                            <span className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-medium text-[#556B2F]">|</span>
                            <span className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-medium text-[#556B2F] font-['Cormorant_SC']">07</span>
                            <span className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-medium text-[#556B2F]">|</span>
                            <span className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-medium text-[#556B2F] font-['Cormorant_SC']">28</span>
                        </div>

                        {/* Gün Bilgisi */}
                        <div className="mb-12 md:mb-16">
                            <p className="text-base md:text-xl lg:text-2xl xl:text-3xl uppercase tracking-widest text-[#556B2F] font-['Cormorant_SC']">
                                CUMARTESİ
                            </p>
                        </div>

                        {/* Çift İsimleri */}
                        <div className="mb-4 md:mb-8">
                            <h2 className="text-5xl md:text-6xl lg:text-7xl font-light text-[#6B7069] font-['Playfair_Display'] italic mb-2">
                                Helin
                            </h2>
                            <p className="text-lg md:text-xl lg:text-2xl uppercase tracking-widest text-[#556B2F] font-['Cormorant_SC'] mb-2">
                                V E
                            </p>
                            <h2 className="text-5xl md:text-6xl lg:text-7xl font-light text-[#6B7069] font-['Playfair_Display'] italic">
                                Harun
                            </h2>
                        </div>
                    </div>
                </div>

                {/* Çiçek Görseli - Sağ tarafta konumlandırılmış */}
                <div className="absolute right-4 md:right-8 lg:right-12 xl:right-16 top-1/2 transform -translate-y-1/2 hidden md:block">
                    <div className="relative">
                        <img
                            src={nisanFlower}
                            alt="Nişan Çiçeği"
                            className="w-96 lg:w-[28rem] xl:w-[32rem] h-auto object-contain opacity-90"
                            style={{
                                filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.1))'
                            }}
                        />
                    </div>
                </div>

                {/* Mobil için çiçek görseli - Arka planda hafif görünür */}
                <div className="absolute right-0 top-1/2 transform -translate-y-1/2 md:hidden">
                    <div className="relative">
                        <img
                            src={nisanFlower}
                            alt="Nişan Çiçeği"
                            className="w-64 h-auto object-contain opacity-20"
                        />
                    </div>
                </div>

                {/* Adres Bilgisi - Alt kısımda sol tarafa konumlandırılmış */}
                <div className="absolute bottom-6 md:bottom-10 lg:bottom-16 left-0 w-full md:w-1/2 md:ml-40 lg:ml-80 xl:ml-96 px-6 md:px-0">
                    <div className="flex items-center mb-4">
                        <svg className="w-6 h-6 text-[#556B2F] mr-2" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                        </svg>
                        <div>
                            <p className="text-sm md:text-base lg:text-lg text-[#556B2F] font-['Cormorant_SC'] uppercase tracking-wider">
                                Atatürk Mah. Gazi Bulvarı No: 12
                            </p>
                            <p className="text-sm md:text-base lg:text-lg text-[#556B2F] font-['Cormorant_SC'] uppercase tracking-wider">
                                10100 Karesi/Balıkesir
                            </p>
                        </div>
                    </div>
                </div>

                {/* Geri Sayım - Mobil görünümde gizli */}
                <div className="hidden absolute bottom-4 right-4 bg-white/80 backdrop-blur-sm p-2 rounded-lg">
                    <div className="flex space-x-2 text-xs text-gray-700">
                        <div>
                            <span className="font-bold">{timeLeft.days}</span>
                            <span className="ml-1">gün</span>
                        </div>
                        <div>
                            <span className="font-bold">{timeLeft.hours}</span>
                            <span className="ml-1">saat</span>
                        </div>
                        <div>
                            <span className="font-bold">{timeLeft.minutes}</span>
                            <span className="ml-1">dk</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Bilgi Bölümü */}
            <section id="engagement-info" className="py-20 bg-white">
                <div className="max-w-6xl mx-auto px-4">
                    <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 font-['Cormorant_SC'] text-gray-900">
                        Nişan Törenimize Davetlisiniz
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                        {/* Çift Hakkında */}
                        <div className="bg-gray-50 p-8 rounded-2xl shadow-lg">
                            <h3 className="text-2xl font-bold mb-6 text-gray-800">Çiftimiz Hakkında</h3>
                            <p className="text-gray-700 mb-6 leading-relaxed">
                                Helin ve Harun, üniversite yıllarında tanıştı. Aynı bölümde okurken başlayan arkadaşlıkları,
                                zamanla büyük bir aşka dönüştü. Üç yıllık birlikteliklerinin ardından,
                                bu özel günde hayatlarını birleştirme kararlarını sizlerle paylaşmak istiyorlar.
                            </p>
                            <div className="flex justify-center">
                                <div className="inline-block bg-white rounded-full p-1">
                                    <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center">
                                        <svg className="w-8 h-8 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Etkinlik Detayları */}
                        <div className="bg-gray-50 p-8 rounded-2xl shadow-lg">
                            <h3 className="text-2xl font-bold mb-6 text-gray-800">Etkinlik Detayları</h3>

                            <div className="space-y-6">
                                <div className="flex items-start space-x-4">
                                    <div className="bg-white p-2 rounded-full">
                                        <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h4 className="font-semibold text-gray-800">Tarih & Saat</h4>
                                        <p className="text-gray-600">1 Temmuz 2028, Cumartesi - 18:00</p>
                                    </div>
                                </div>

                                <div className="flex items-start space-x-4">
                                    <div className="bg-white p-2 rounded-full">
                                        <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h4 className="font-semibold text-gray-800">Konum</h4>
                                        <p className="text-gray-600">Atatürk Mah. Gazi Bulvarı No:12</p>
                                        <p className="text-gray-600">10100 Karesi/Balıkesir</p>
                                    </div>
                                </div>

                                <div className="flex items-start space-x-4">
                                    <div className="bg-white p-2 rounded-full">
                                        <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h4 className="font-semibold text-gray-800">İletişim</h4>
                                        <p className="text-gray-600">helinharun@email.com</p>
                                        <p className="text-gray-600">+90 555 123 4567</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Konum Bölümü */}
            <section className="py-16 bg-gray-50">
                <div className="max-w-6xl mx-auto px-4">
                    <h2 className="text-3xl font-bold text-center mb-12 font-['Cormorant_SC'] text-gray-900">Konum</h2>

                    <div className="bg-white rounded-2xl overflow-hidden shadow-lg">
                        <div className="aspect-w-16 aspect-h-9">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d48192.47489428372!2d29.02776!3d40.9909!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab7650656bd63%3A0x8ca058b28c20b6c3!2zS2FkxLFrw7Z5L8Swc3RhbmJ1bA!5e0!3m2!1str!2str!4v1652000000000!5m2!1str!2str"
                                width="100%"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Nişan Mekanı"
                                className="w-full h-full"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </section>

            {/* Galeri Bölümü */}
            <section className="py-16 bg-white">
                <div className="max-w-6xl mx-auto px-4">
                    <h2 className="text-3xl font-bold text-center mb-12 font-['Cormorant_SC'] text-gray-900">Galeri</h2>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                        {/* Placeholder görsel alanları */}
                        {[1, 2, 3, 4, 5, 6].map((item) => (
                            <div key={item} className="bg-gray-100 rounded-xl overflow-hidden aspect-w-3 aspect-h-4 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                                <div className="w-full h-full flex items-center justify-center text-gray-300">
                                    <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M4 5h16v2H4zm0 6h16v2H4zm0 6h16v2H4z" />
                                    </svg>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* RSVP Bölümü */}
            <section className="py-16 bg-gray-800 text-white">
                <div className="max-w-4xl mx-auto px-4 text-center">
                    <h2 className="text-3xl font-bold mb-8 font-['Cormorant_SC']">Katılım Durumu</h2>
                    <p className="text-lg mb-10 text-gray-100">
                        Nişan törenimize katılım durumunuzu bildirmenizi rica ederiz.
                    </p>

                    <div className="bg-white/10 backdrop-blur-md p-8 rounded-2xl">
                        <form className="space-y-6">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                <div className="text-left">
                                    <label htmlFor="name" className="block text-sm font-medium text-gray-100 mb-1">Ad Soyad</label>
                                    <input
                                        type="text"
                                        id="name"
                                        className="w-full px-4 py-3 bg-white/20 border border-gray-300/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-400 text-white placeholder-gray-200"
                                        placeholder="Adınız Soyadınız"
                                    />
                                </div>
                                <div className="text-left">
                                    <label htmlFor="email" className="block text-sm font-medium text-gray-100 mb-1">E-posta</label>
                                    <input
                                        type="email"
                                        id="email"
                                        className="w-full px-4 py-3 bg-white/20 border border-gray-300/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-400 text-white placeholder-gray-200"
                                        placeholder="E-posta adresiniz"
                                    />
                                </div>
                            </div>

                            <div className="text-left">
                                <label className="block text-sm font-medium text-gray-100 mb-3">Katılım Durumu</label>
                                <div className="space-y-3">
                                    <div className="flex items-center">
                                        <input
                                            type="radio"
                                            id="attending"
                                            name="attendance"
                                            className="w-4 h-4 text-gray-600 focus:ring-gray-500"
                                        />
                                        <label htmlFor="attending" className="ml-3 text-white">Katılacağım</label>
                                    </div>
                                    <div className="flex items-center">
                                        <input
                                            type="radio"
                                            id="not-attending"
                                            name="attendance"
                                            className="w-4 h-4 text-gray-600 focus:ring-gray-500"
                                        />
                                        <label htmlFor="not-attending" className="ml-3 text-white">Katılamayacağım</label>
                                    </div>
                                    <div className="flex items-center">
                                        <input
                                            type="radio"
                                            id="maybe"
                                            name="attendance"
                                            className="w-4 h-4 text-gray-600 focus:ring-gray-500"
                                        />
                                        <label htmlFor="maybe" className="ml-3 text-white">Belki katılabilirim</label>
                                    </div>
                                </div>
                            </div>

                            <div className="text-left">
                                <label htmlFor="message" className="block text-sm font-medium text-gray-100 mb-1">Mesajınız (İsteğe bağlı)</label>
                                <textarea
                                    id="message"
                                    rows="4"
                                    className="w-full px-4 py-3 bg-white/20 border border-gray-300/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-400 text-white placeholder-gray-200"
                                    placeholder="Çifte iletmek istediğiniz mesajı yazabilirsiniz"
                                ></textarea>
                            </div>

                            <div>
                                <button
                                    type="submit"
                                    className="px-8 py-3 bg-white text-gray-900 font-medium rounded-lg hover:bg-gray-100 transition-colors duration-300"
                                >
                                    Gönder
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="py-8 bg-gray-900 text-gray-300 text-center">
                <div className="max-w-6xl mx-auto px-4">
                    <p className="mb-4">Helin & Harun</p>
                    <p className="text-sm">1 Temmuz 2028</p>
                </div>
            </footer>
        </div>
    );
};

export default Engagement; 